<template>
	<div :class="['carWarp',{'cur':isShowCarList}]">
		<section id="brandWarp" class="carWarpItem brandWarp">
			<div id="headerTag" class="clearfix headerTag">
				<a @click="isShowCarList = false" class="fl back" href="javascript:void(0)">返回</a>
				<span  style="margin-left:2rem;">交强险</span>
			</div>
			<div id="carContentBrand" class="carContent carContentBrand">
				<div class="brandListWarp">
					<dl v-for="(item,index) in brandList" class="brandList">
						<dd @click="showCarStyle(item)" class="brandListItem">
							<span class="brandListItemName" v-text="item.name"></span>
						</dd>
					</dl>
				</div>
			</div>
		</section>
	</div>

</template>
<style scoped lang="less">
@import url('../../../assets/less/common.less');
.headerTag{
	top:0;
	left:0;
	width:100%;
	padding:0;
}
.carWarp{
	display: none;
	position: absolute;
	top:0;
	left:100%;
	width:100%;
	height:100%;
	background: #adaeb1;
	transition: left 0.5s;
	-moz-transition: left 0.5s; /* Firefox 4 */
	-webkit-transition: left 0.5s; /* Safari 和 Chrome */
	-o-transition: left 0.5s; /* Opera */
	.carWarpItem{
		position: relative;
		width:70%;
		height:100%;
		overflow: hidden;
		background: #fff;
		left:30%;
		.carContent{
			position: relative;
			overflow-x: hidden;
			overflow-y: auto;
			//-webkit-overflow-scrolling:touch;
			//overflow-scrolling:touch;
			.letter-wrap{
				position: fixed;
				top:1.173333rem;
				right:0;
				overflow: scroll;
				background: #fff;
			    ul.letter-Ul {
			    	li{
			    	    padding: 2px 6px;
				    }
			    }
			   
			}
		}
	}
	.choiceCarTag{
		.px2px(font-size,30px);
		background: #fff;
		padding:0.2rem 0.4rem;
	}


	/*品牌列表*/
	.brandListWarp{
		margin-top: 0.266667rem;
		.brandList{
			background: #fff;
			.brandListItem{
				position: relative;
				margin:0 0.2rem;
				height:1.5rem;
				border-bottom: 1px solid #eaeaea;
				img{
					position: absolute;
					left:0.2rem;
					top:50%;
					margin-top: -0.533333rem;
					width:1.066667rem;
					height:1.066667rem;
					vertical-align: middle;
				}
				.brandListItemName{
					display: inline-block;
					.px2px(font-size,30px);
					line-height: 1.5rem;
					margin-left: 0.7rem;
				}
			}
		}
	}
	.carStyleWarp,.modelWarp{
		position: absolute;
		display: none;
		top:0;
		left:30%;
	}
	.carStyleWarp.cur,.modelWarp.cur{
		display: block;
		left:30%;
	}
}
.carWarp.cur{
	display: block;
	left:0
}
.fl {
    float: left;
    display: inline-block;
}




</style>
<script>
	import MsgBus from "../../../assets/bus/bus.js"	
	import { Toast } from 'mint-ui';
	import { Indicator } from 'mint-ui';
	export default {
		name: 'comparison',
		data:function() {
			return {
				//记录当前滚动距离
				scrollParams:{
					winScrollTop:0,
					tagOffsetTop:[],
				},
				//是否展示品牌车型内容
				isShowCarList:false,
				isShowCarStyle:false,
				isShowModel:false,
				carInfor:{
					name:'',
					styleName:'',
					year:'',
					showLoadContent:false,
				},
				brandList:[
					 		{
					 			id:0,
					 			name:"家庭6座以下",
					 			value:950
					 		},
					 		{
					 			id:1,
					 			name:"家庭6座以上",
					 			value:1100
					 		}
					 		
					 	],
					
				seleted:0,
				fullpage:false,
				loadpage:false,
				resultPage:false,
			}
		},
		mounted: function(){
		},
		methods: {
			initSideIn:function(showCom,showResult){
				var self =this;
				self.carInfor.showLoadContent=showCom;
				self.resultPage=showResult;
				this.initWeb();

					
			},
			initWeb:function(){
				var self = this;
				self.ajaxSubmit.ajax({
					url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.comparisonBrandList,
					type:"get",
					success:function(data){
						if(data.responseHeader.status == 200){
							self.hotCarList = data.response.result.hotCarList;
							for(var i in data.response.result.brandList){
								self.$set(self.brandList,i,data.response.result.brandList[i]);
								self.showCarList();
								setTimeout(function(){
									self.setContent();
									self.getTagOffsetTop();
								},1000);
							}	
						}
					},
					error:function(){}
				})
			},
			setContent:function(){
				var self = this;
				var oCarContentBrand = document.getElementById("carContentBrand");
				var oCarContentCarStyle = document.getElementById("carContentCarStyle");
				var oCarContentModel = document.getElementById("carContentModel");
				var oLetterUl = document.getElementById("letter-Ul");
				var winHeight = document.documentElement.clientHeight || document.body.clientHeight;
				//初始化carContent的高度
				var headerTagHeight = document.getElementById("headerTag").offsetHeight;
				oCarContentBrand.style.height = (winHeight - headerTagHeight) + "px";
				oCarContentCarStyle.style.height = (winHeight - headerTagHeight) + "px";
				oCarContentModel.style.height = (winHeight - headerTagHeight) + "px";
				oLetterUl.style.height = (winHeight - headerTagHeight) + "px";

			},
			//记录所有便签距离页面顶部的距离
			getTagOffsetTop:function(){
				var oCarInfoContent = document.getElementById("carContentBrand");
				var oCarInfoContentDl = oCarInfoContent.getElementsByClassName("choiceCarTag");
				for(var i=0;  i < oCarInfoContentDl.length; i++){
					this.scrollParams.tagOffsetTop.push(oCarInfoContentDl[i].offsetTop);
				}
			},
			//页面按照点击滚动到锚点
			scrollWinTag:function(index){
				$(document.getElementById("carContentBrand")).scrollTop(this.scrollParams.tagOffsetTop[index]);
			},

			//展示侧拉框
			closeAll:function(){
				this.isShowCarList = false;
			},
			showCarList:function(){
				this.isShowCarList = true;
			},
			showCarStyle:function(obj){
				var self = this;
				var objData={};
				objData.id=obj.id;
				objData.name=obj.name;
				objData.value=obj.value;
				if(obj){
					if(self.resultPage==true){
						MsgBus.$emit('msgInfoInsu', obj);
					}
					self.isShowCarList = false;
				}else{
					self.isShowCarList = true;
				}
				

			},

			//选择车款Id
			checkModelId:function(item,year){
				var self=this;
				item.year = year;
				self.ajaxSubmit.ajax({
					url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.comparisonListbycarids,
					type:"get",
					data:{
						carIds:item.id 
					},
					success:function(data){
						if(data.responseHeader.status == 200){
							self.carInfor.name=data.response.result[0].carName;
							self.carInfor.styleName=data.response.result[0].carStyleName;
							self.carInfor.year=data.response.result[0].year;
							
							
						}
					},
					error:function(){
					}
				})
				//关闭
				this.closeAll();
			}

		}
	}
</script>


// WEBPACK FOOTER //
// src/components/calculator/markInsurance/markI.vue